import * as React from "react";

var OfflinePlaceholder = function OfflinePlaceholder() {
  return React.createElement(React.Fragment, null, "OFFLINE :(");
};

export default OfflinePlaceholder;